<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="level">
      <div class="level-left">
        <h1 class="title is-5">{{ $t('docflow.docTypes.incoming') }}</h1>
      </div>
      <div class="level-right" v-if="isDocflowManager || isSuperUser">
        <div class="field is-grouped controls">
          <button @click="$router.push({name: 'createIncomingDocflow'})"
                  class="button is-success">
            {{ $t('docflow.newDocument') }}
          </button>
        </div>
      </div>
    </div>
    <div class="container is-fluid">
      <IncomingList :data="data"
                    :loading="loading"
                    :total="total"
                    :perPage="perPage"
                    :sort-field="sortField"
                    :sort-order="sortOrder"
                    @search="loadData"
                    @filter="loadData"
                    @page-change="onPageChange"
                    @sort="onSort"
                    @reset-filters="loadData">
      </IncomingList>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import IncomingList from '@/components/IncomingList'
  import OutgoingList from '@/components/OutgoingList'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'

  export default {
    components: {
      DashboardLayout,
      GovernmentAgencySelect,
      IncomingList,
      OutgoingList
    },
    data() {
      return {
        data: [],
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        sortField: '',
        sortOrder: 'desc',
        category: 'incoming'
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.$store.dispatch('Docflow/list', {
          category: this.category,
          page: this.page,
          page_size: this.perPage,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`,
          ...this.prepareFilter('incomingFilters')
        }).then((data) => {
          this.loading = false
          this.total = data.count
          this.data = data.results
        })
      },
      onSort({field, order}) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      }
    },
    mounted() {
      this.page = this.incomingFilters.page
      this.loadData()
    },
    computed: {
      ...mapState('Docflow', ['list']),
      ...mapState('Filters', ['incomingFilters']),
      ...mapGetters('Account', ['isDocflowManager', 'isSuperUser']),
      ...mapGetters('Filters', ['prepareFilter']),
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowIncoming'}
        ]
      }
    }
  }
</script>
